// extracted by mini-css-extract-plugin
export default {"payment":"Bt","title_row":"Ct","border_bottom":"Et","promo_wrapper":"Ft","payment_wrapper":"Gt","label":"Ht","card_row":"It","cardcontain":"Jt","card_input":"Kt","card_error":"Lt","card_label":"Mt","lock":"Nt","same_address":"Ot","place_order_button":"Pt","buttonwrap":"Qt","hide_form":"Rt","paypal_buttons":"St","review_button":"Tt","alt_payment":"Ut"};
    if(module.hot) {
      // 1715632474967
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  